/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Components/Global                                                                    **/
/**************************************************************************************************/
import * as CompanyLogo from '@/Components/Global/CompanyLogo/template.vue'
import * as InitialsButton from '@/Components/Global/InitialsButton/template.vue'
import * as NotificationsButton from '@/Components/Global/NotificationsButton/template.vue'

/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { Documents } from '@/Constants/Documents'
import { VueRouter } from '@/Constants/VueRouter'

/**************************************************************************************************/
/** @import Mixins                                                                               **/
/**************************************************************************************************/
import MixinComponent from '@/Mixins/MixinComponent'
import MixinResponsive from '@/Mixins/MixinResponsive'

/**************************************************************************************************/
/** @import Store/Global                                                                         **/
/**************************************************************************************************/
import Store from '@/Store/Global/Default'

/**************************************************************************************************/
/** @internal Const @name BasicHeader                                                            **/
/**************************************************************************************************/
const BasicHeader = defineComponent(
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	name: 'BasicHeader', mixins: [MixinComponent, MixinResponsive],

	components:
	{
		InitialsButton: InitialsButton.default,
		CompanyLogo: CompanyLogo.default,
		NotificationsButton: NotificationsButton.default
	},

	props:
	{
		showNotificationsButton: { type: Boolean, default: true },
		title: { type: String, default: '' }
	},

	/*************************************************/
	/** @Data                                       **/
	/*************************************************/
	data()
	{
		return {
			states:
			{
				isMobile: false,
				logoutParams: {},
				redirectToHome: true
			}
		}
	},

	/*************************************************/
	/** @Computed                                   **/
	/*************************************************/
	computed:
	{
		IsModuleEnvironmentExternal() : boolean
		{
			return (this.GetComponentParamModuleEnvironment === 'External') as boolean
		},

		NotificationsButton() : NotificationsButton.NotificationsButtonRef
		{
			return this.$refs.notificationsButton as NotificationsButton.NotificationsButtonRef
		}
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		async OnLogoClick() : Promise<void>
		{
			const parentViewName = this.$options.parent!.$options.name
			const currentRoute = this.$route.name
			switch (Store.getters.getStoredUser._idRole)
			{
				case Documents.Roles.Kreis.CLIENT:
				{
					if (parentViewName !== VueRouter.Views.Modules.EXTERNAL_CPANEL.NAME && currentRoute !== VueRouter.Views.Modules.EXTERNAL_CPANEL.NAME)
					await this.$router.push({ name: VueRouter.Views.Modules.EXTERNAL_CPANEL.NAME })
					break
				}
				default:
				{
					if (parentViewName !== VueRouter.Views.Modules.INTERNAL_CPANEL.NAME && currentRoute !== VueRouter.Views.Modules.INTERNAL_CPANEL.NAME)
					await this.$router.push({ name: VueRouter.Views.Modules.INTERNAL_CPANEL.NAME })
					break
				}
			}
		},

		OnLogoutClick() : void
		{
			Store.dispatch('onDestroyAllData')
			Store.getters.getStoredSocket.emit('userLoggedOut')
			this.$router.push({ name: VueRouter.Views.Global.LOGIN.NAME, params: { successLogout: 'true', ...this.states.logoutParams } })
		}
	}
})

/**************************************************************************************************/
/** @export Component @name BasicChart                                                           **/
/**************************************************************************************************/
export default BasicHeader

/**************************************************************************************************/
/** @export Type @name BasicHeaderRef                                                            **/
/**************************************************************************************************/
export type BasicHeaderRef = InstanceType<typeof BasicHeader>